import Constants from '@/Constants';
import { Workshop } from '@/models/Workshop';
import { WorkshopMeeting } from '@/models/WorkshopMeeting';
import { currentDate, momentWithTimeZone } from '@/services/UtilService';
import { ApplicationState } from '@/store';
import { isBefore } from 'date-fns';
import React, { Fragment, useMemo } from 'react';
import MagicSliderDots from 'react-magic-slider-dots';
import { useSelector } from 'react-redux';
import Slider from 'react-slick';
import './style.scss';
import Tips from './Tips';

interface Props {
    workshop: Workshop | undefined;
}

const WorkshopSlider = ({ workshop }: Props) => {
    const strings = useSelector((state: ApplicationState) => state.locale.data);

    const getCarouselDots = (dots: boolean): JSX.Element => <MagicSliderDots dotWidth={30} dots={dots} numDotsToShow={4} />;

    const styleLabel = (online: boolean): string => {
        return `${!online ? `workshop-label__not-online` : `workshop-label`} `;
    };

    const isMeetingDisabled = (endDate: Date): boolean => {
        return isBefore(endDate, Date.now());
    };

    const initialSlideIndex = useMemo((): number => {
        if (workshop?.meetings) {
            const index: number = workshop.meetings.findIndex((next) => isBefore(currentDate(), next.endDate));
            return index !== -1 ? index : 0;
        }
        return 0;
    }, [workshop?.meetings]);

    return (
        <div className="workshop-container">
            {workshop && (
                <div className="container-carousel" key={workshop.id}>
                    <div className="workshop-top">
                        <div className={`${styleLabel(workshop.isOnline)} `}>
                            <p className="title">{workshop.isOnline ? strings.WORKSHOP_TYPE_ONLINE : strings.WORKSHOP_TYPE_IN_PERSON}</p>
                        </div>
                        {/*** VAI ENTRAR numa próxima história
                <div className="container-buttons">
                    <button className="button-calendar" type="button">
                        <span className="title-button-calendar">Adicionar ao calendário</span>
                    </button>

                    <button className="button-confirm"  type="button">
                        Confirmar presença
                    </button>
                </div> */}
                    </div>
                    <div className="container-workshop">
                        {workshop.meetings && workshop.meetings.length > 0 && (
                            <div className="container carrosell-slide-container">
                                <Slider
                                    appendDots={getCarouselDots}
                                    dots={true}
                                    infinite={false}
                                    initialSlide={initialSlideIndex}
                                    slidesToScroll={1}
                                    slidesToShow={1}
                                    speed={500}
                                >
                                    {workshop.meetings.map((meeting: WorkshopMeeting) => (
                                        <Fragment key={meeting.id}>
                                            <div className={`container-events ${isMeetingDisabled(meeting.endDate) ? `workshop-disable` : ''}`}>
                                                <i className="material-icons">{Constants.icons.CALENDAR_TODAY}</i>
                                                <div className="date">
                                                    <span className="startDate">{momentWithTimeZone(meeting.startDate, strings._LANGUAGE)}</span>
                                                </div>
                                                <i className="material-icons-outlined">{Constants.icons.ACCESS_TIME}</i>
                                                <div className="container-workshop-start">
                                                    <span className="workshop-start">
                                                        {momentWithTimeZone(meeting.startDate, strings._LANGUAGE, false, true)} •
                                                    </span>
                                                </div>
                                                <div className="container-workshop-finish">
                                                    <span className="container-workshop-finish__time-finishDate">
                                                        {momentWithTimeZone(meeting.endDate, strings._LANGUAGE, false, true)} •
                                                    </span>
                                                </div>
                                                <span className="title-workshop-events__timezone">{strings.BRAZILIA_TIME}</span>
                                            </div>
                                            <div className={`workshop-info  ${isMeetingDisabled(meeting.endDate) ? `workshop-disable` : ''}`}>
                                                <div className="workshop-info-center">
                                                    <span
                                                        className="label"
                                                        dangerouslySetInnerHTML={{
                                                            __html: `${workshop.isOnline ? strings.WORKSHOP_LINK : `${strings.WORKSHOP_ADDRESS}:`}`,
                                                        }}
                                                    />
                                                    {workshop.isOnline ? (
                                                        <a
                                                            className={`${isMeetingDisabled(meeting.endDate) ? `link__disabled` : `link`}`}
                                                            href={workshop.address}
                                                            rel="noreferrer"
                                                            target="_blank"
                                                        >
                                                            {workshop.address}
                                                        </a>
                                                    ) : (
                                                        <a className="link__presential">{workshop.address}</a>
                                                    )}
                                                </div>
                                                <div className="workshop-info-center">
                                                    <span
                                                        className="label"
                                                        dangerouslySetInnerHTML={{
                                                            __html: `${strings.WORKSHOP_MINISTERED_BY}`,
                                                        }}
                                                    />
                                                    <span className="info-center">{workshop.host}</span>
                                                </div>
                                                <Tips tip={workshop.tips} />
                                            </div>
                                        </Fragment>
                                    ))}
                                </Slider>
                            </div>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default WorkshopSlider;
